<template>
  <v-app class="app">
    <AppBar />

    <v-main>
      <MainScreen />
    </v-main>

    <Footer />
  </v-app>
</template>

<script>
import Footer from '@/componentes/Footer'

import AppBar from '../_components/AppBar'
import MainScreen from './MainScreen.vue'

export default {
  components: { AppBar, Footer, MainScreen },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
